import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

// Food Pantry CTA Section
const FoodPantryCTA = () => {
  return (
    <section 
      data-testid="food-pantry-cta"
      className="pb-8 px-4 md:px-8 lg:px-12 bg-[#FAFAFA]"
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link 
            to="/get-help/food"
            data-testid="food-pantry-cta-link"
            className="inline-flex items-center gap-2 bg-[#C41E3A] hover:bg-[#a31830] text-white text-lg md:text-xl font-semibold px-8 py-4 rounded-full transition-colors"
          >
            Click here if you need food
            <ChevronRight size={24} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FoodPantryCTA;
